import { useParams } from 'react-router';
import NewExitDestinationForm from './new';

export default function EditExitDestinationForm() {
  const { exitDestination = '' } = useParams();

  return <NewExitDestinationForm isEdit currentExitDestination={exitDestination} />;
}
